import React from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { Controller, useFormContext } from 'react-hook-form';

import { AssignToItemTemplate, FormLabel } from 'modules/automation/WorkflowBuilder/components';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import { formatUserDropdown } from 'modules/automation/utils/formatUserDropdown';
import { automationModules } from 'constants/automation';

const TaskAssignTo = ({ userList, isFirmUserLoading, index }) => {
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext();

  const trigger = watch('trigger') || {};
  const isForLeadAutomation =
    watch('is_lead_automation') || (trigger?.module === automationModules.LEADS && trigger?.code !== 'TRIG_LEAD_CONV_CASE');

  return (
    <div className="col-12">
      <FormLabel label="Assign To" isRequired className="p-medium" />
      <Controller
        name={`actions[${index}].assignTo`}
        control={control}
        rules={{ required: 'Required' }}
        render={({ field: { name, value, onChange, ref } }) => (
          <MultiSelect
            name={name}
            value={value ?? []}
            options={
              formatUserDropdown({
                users: userList,
                hideInactive: true,
                includeContacts: false,
                includesUserGroups: true,
                includesTeamMembers: true,
                includePrimarySecondary: true,
                isLead: isForLeadAutomation,
                includeSelectedInactiveUser: true,
                includeSelectedInactiveUserGroup: true,
                selectedItems: value || [],
              }) || []
            }
            placeholder="Please Select Assignees"
            className="w-100 p-dropdown p-component p-inputwrapper"
            filter
            onChange={(e) => onChange(e.value)}
            optionValue={(v) => ({ value: v?.value, res_type: v?.res_type })}
            display="chip"
            optionLabel="label"
            optionGroupLabel="groupLabel"
            optionGroupChildren="items"
            itemTemplate={AssignToItemTemplate}
            dropdownIcon={isFirmUserLoading ? 'pi pi-spin pi-spinner' : undefined}
            inputRef={ref}
          />
        )}
      />
      <RequiredValidation errors={errors} field={`actions.${index}.assignTo`} />
      {isForLeadAutomation && (
        <div className="d-flex align-items-start mt-2 files-note">
          <i className="pi pi-info-circle me-1 mt-1"></i>
          <span>If 'On Behalf Of' contact is not available, 'Client' will be used automatically, even if not selected.</span>
        </div>
      )}
    </div>
  );
};

export default TaskAssignTo;
